import PropTypes from 'prop-types';
import React, { Component } from 'react';

import SettingsPage from '@/components/SettingsPage';
import SettingsPageContent from '@/components/SettingsPageContent';
import SettingsPageHeader from '@/components/SettingsPageHeader';
import SettingsPageTitle from '@/components/SettingsPageTitle';

import Form from './Form';

class EditContacts extends Component {
  static propTypes = {
    fetchSettings: PropTypes.func.isRequired,
    isFinished: PropTypes.bool.isRequired,
    updateContacts: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { fetchSettings } = this.props;

    fetchSettings();
  }

  render() {
    const { isFinished, updateContacts } = this.props;

    if (!isFinished) {
      return null;
    }

    return (
      <SettingsPage>
        <SettingsPageHeader>
          <SettingsPageTitle>Контактная информация</SettingsPageTitle>
        </SettingsPageHeader>
        <SettingsPageContent>
          <Form onSubmit={updateContacts} />
        </SettingsPageContent>
      </SettingsPage>
    );
  }
}

export default EditContacts;
